/* eslint-disable import/no-unresolved */
import Page from 'src/components/Page';
import PropTypes from 'prop-types';
import { Card, Container, Typography, Button, Stack, Box, Grid, CardContent, CardActions } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import { useState } from 'react';
import FullDialog from 'src/components/common-components/FullDialog';

ReportCards.propTypes = {
  cardInfo: PropTypes.array
};

export default function ReportCards({ handleClose, cardInfo }) {
  const { themeStretch } = useSettings();
  return (
    <Page title="Reports | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
        {/* <Card sx={{ p: 3 }}> */}
        <Grid container spacing={2}>
          {cardInfo.map((card) => (
            <Grid key={card.title} item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActions onClick={() => {}}>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {card.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {card.caption}
                    </Typography>
                  </CardContent>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Page>
  );
}
